import React, { useState, useEffect, useRef } from 'react';
import './Home.css';

export default function Home() {
  const [logoVisible, setLogoVisible] = useState(false);
  const imageRefs = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      imageRefs.current.forEach((imageRef) => {
        if (imageRef) {
          const rect = imageRef.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
          if (isVisible) {
            imageRef.classList.add('slide-in');
          } else {
            imageRef.classList.remove('slide-in');
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const typingAnimationDuration = 1350;

    const timer = setTimeout(() => {
      setLogoVisible(true);
    }, typingAnimationDuration);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="Home" className="tabcontent">
      <div className="header-container">
    <div className="typing-text-container">
      <h1 className="typing-text">Welcome to...</h1>
    </div>
      {logoVisible && (
        <div className="logo-container">
          <img src="/img/nocturne-lettering.svg" alt="Logo" className="logo" />
        </div>
      )}
    </div>
    <div className="link-container">
    <a href="https://ra.co/events/2243135" className="link-button" alt="Electropolis | Halloween Edition" target="_blank" rel="noopener noreferrer">Electropolis | Halloween Edition<br/> 31 October - Tickets</a>
      <a href="https://nocturnemlb.secure-decoration.com" className="link-button" alt="Nocturne Merch Store" target="_blank" rel="noopener noreferrer">🦇 Merch 🦇</a>
      <a href="/mailing-list" className="link-button" alt="Mailing list">Join The Nocturne Family 🦇<br/> Sign Up to Our Mailing List </a>
    </div>
  </div>
  );
}
